<template>
  <div class="p-j03-a-result-screen">
    <div v-if="heading" class="p-j03-a-result-screen__header">
      <h2 class="p-j03-a-result-screen__heading">
        {{ heading }}{{ itemCountString }}
      </h2>
    </div>
    <div class="p-j03-a-result-screen__body">
      <JMessageArticleList
        :message-article-list="resultArray"
        :exclude="exclude"
      />
    </div>
  </div>
</template>

<script lang="ts">
import JMessageArticleList from "@/general/components/pages/parts/ThanksPointList/JMessageArticleList.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    resultArray: { type: Array, required: true },
    exclude: { type: Array, default: () => ([]) },
    heading: { type: [String, Boolean], required: true },
    messagesSearchResultsCount: { type: [Boolean, Number], default: false }
  },
  components: {
    JMessageArticleList
  }
})
export default class J03AResultScreen extends Vue {
  resultArray!: any;
  exclude!: any;
  heading!: string | boolean;
  messagesSearchResultsCount!: boolean | number;

  get itemCount() {
    return this.messagesSearchResultsCount;
  }

  get itemCountString() {
    const itemCount = this.itemCount;
    if (!itemCount) {
      return `（0件）`;
    }
    return `（${itemCount}件）`;
  }
}
</script>

<style lang="scss" scoped>
.p-j03-a-result-screen {
  &__inner {
  }
  &__header {
  }

  &__heading {
    @include pc {
      font-size: $text-size__body--l;
    }
    font-weight: bold;
  }

  &__body {
    margin-top: rem(8);
  }
}
</style>
